export default "<p>Bienvenue !</p>\n<p>{{ utilisateur.prenom + ' ' + utilisateur.nom }}</p>\n<p>{{ utilisateur.nomEmploi}} ({{ utilisateur.filiere.code }})</p>"